module.exports = __webpack_public_path__ + "static/media/first-time-offer.ce776717.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/coupons/first-time-offer.jpg
// module id = 492
// module chunks = 0